import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { EntityContext } from 'context/entityContext';
import getArtistIdsByEntityIds from 'helpers/getArtistIdsByEntityIds';
import { RootState } from 'redux/rootReducer';

export default useArtistIds;

/**
 * This hook returns the artist id's that correspond to the current contexts' entity id's.
 */
function useArtistIds(): string[] | undefined {
  const { entityIds, entityType } = useContext(EntityContext);

  const artistIds = useSelector((state: RootState) =>
    getArtistIdsByEntityIds(state, { entityIds, entityType })
  );

  return artistIds;
}
